import { Group, HoverCard, Stack, createStyles } from '@mantine/core';
import type { QueryLiteSecodaEntity } from '@repo/api-codegen';
import { getSummaryAndBreadCrumbs } from '@repo/common/utils/breadcrumb';
import { Text } from '@repo/foundations';
import IntegrationLogo from '../../../components/IntegrationLogo/IntegrationLogo';

interface UseStylesProps {
	hasDetails: boolean;
}

const useStyles = createStyles((theme, { hasDetails }: UseStylesProps) => ({
	dropdown: {
		maxWidth: '268px',
		borderRadius: theme.radius.md,
		padding: 0,
		boxShadow: '0px 6px 16px 0px rgba(0, 0, 0, 0.12)',
		overflow: 'hidden',
	},
	title: {
		cursor: 'pointer',
		padding: hasDetails
			? `${theme.spacing.md} ${theme.spacing.sm} ${theme.spacing.sm} ${theme.spacing.sm}`
			: theme.spacing.sm,
		overflowWrap: 'anywhere',
	},
	iconWrapper: {
		backgroundColor: theme.other.getColor('surface/secondary/default'),
		borderRadius: theme.radius.xs,
		minWidth: theme.other.space['7'],
		height: theme.other.space['7'],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: theme.other.space['1'],
	},
}));

interface QueryResourcePreviewProps {
	query: QueryLiteSecodaEntity;
	children: React.ReactNode;
}

export function QueryResourcePreview({
	query,
	children,
}: QueryResourcePreviewProps) {
	const { classes } = useStyles({ hasDetails: false });

	const breadcrumb = getSummaryAndBreadCrumbs(
		query.entity_type ?? null,
		undefined
	);

	return (
		<HoverCard openDelay={500} withinPortal>
			<HoverCard.Target>{children}</HoverCard.Target>
			<HoverCard.Dropdown className={classes.dropdown}>
				<Stack spacing={0}>
					<Group
						spacing="xs"
						align="flex-start"
						className={classes.title}
						noWrap
					>
						<div className={classes.iconWrapper}>
							<IntegrationLogo
								integrationId={query.integration_id ?? undefined}
							/>
						</div>
						<Stack spacing={0}>
							<Text size="sm" fw="bold" color="text/primary/default">
								{query.title ?? 'Untitled'}
							</Text>
							<Text size="xs" color="text/secondary/default">
								{breadcrumb}
							</Text>
						</Stack>
					</Group>
				</Stack>
			</HoverCard.Dropdown>
		</HoverCard>
	);
}
